module.exports = __webpack_public_path__ + "static/media/wechat-qr-banner.dc8a6da0.jpg";